import { useCallback, useRef, useState } from 'react';
import { useMutation } from 'react-query';
import { CancelToken } from 'axios';

/*
"cancelToken: CancelToken.token" - this API is deprecated since v0.22.0
"signal: AbortController.signal" - supports starting from v0.22.0 Axios
*/
export const useUploadMutation = (requestBuilder, mutationOptions) => {
  const [progress, setProgress] = useState(0);
  const resetProgress = () => setProgress(0);

  const cancelTokenRef = useRef(null);
  const abortControllerRef = useRef(null);

  const mutation = useMutation((...args) => {
    cancelTokenRef.current = CancelToken.source();
    abortControllerRef.current = new AbortController();
    return requestBuilder(...args, {
      onUploadProgress: (ev) => {
        setProgress(Math.round((ev.loaded * 100) / ev.total));
      },
      cancelToken: cancelTokenRef.current.token,
      signal: abortControllerRef.current.signal,
    });
  }, mutationOptions);

  const abort = useCallback(
    (reasonText) => {
      // eslint-disable-next-line no-unused-expressions
      abortControllerRef.current?.abort(reasonText);

      // eslint-disable-next-line no-unused-expressions
      cancelTokenRef.current?.cancel(reasonText);

      mutation.reset();
      resetProgress();
    },
    [mutation]
  );

  return { mutation, progress, abort, resetProgress };
};
